import React, { useState, useEffect, useContext } from "react";
import DataTable from "../components/DataTableComponents";
import IconUI from "../components/iu/icon_ui";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Tooltip } from "@mui/material";
import LoaderComponent from "../components/admin/LoaderComponent";
import {
  Box,
  Modal,
  TextField,
  MenuItem,
  Autocomplete,
  FormGroup,
  FormLabel,
} from "@mui/material";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AiOutlineEdit, AiOutlineDelete } from "react-icons/ai";
import { GrDocumentDownload } from "react-icons/gr";
import { maxLengthLimitInput, onlyNumber } from "../utils/inputsRules";
import { services } from "../services/api";
import { NotificacionContext } from "../context/notificacion_context";
import "dayjs/locale/es";

const ActaCircunstanciadaView = () => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "2px solid #661d40",
    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    overflowY: "scroll",
    height: 600,
    borderRadius: "40px",
    scrollbarWidth: "none",
  };

  const style2 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "2px solid #661d40",
    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    overflowY: "scroll",
    height: "auto",
    borderRadius: "40px",
    scrollbarWidth: "none",
  };

  const style3 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: {
      xs: "90%",
      sm: "80%",
      md: 1200,
    },
    bgcolor: "background.paper",
    border: "2px solid #661d40",
    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    overflowY: "scroll",
    height: {
      xs: "90vh",
      sm: "80vh",
      md: "90%",
    },
    borderRadius: "40px",
  };

  const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText("#005cbf"),
    backgroundColor: "#661d40",
    "&:hover": {
      backgroundColor: "#661d40",
    },
    borderRadius: "40px",
  }));

  const {showNotification} = useContext(NotificacionContext);
  const [loader, setLoader] = useState({ loading: true });
  const [state, setState] = useState({
    delitos: [],
    acta: [],
    actaSeleccionada: {},
    openModalEditar: false,
    openModalEliminar: false,
    openDocumento: false,
    urlFrame: "",
  });

  const [formularioState, setFormulario] = useState({
    name: "",
    date: "",
    phone: "",
    ofice_number: "",
    fiscaly_area: "",
    victim_type: "",
    crime_id: "",
    case_number: "",
    no_answer: "",
    complaint: "",
    // employee_id: "",
  });

  const [errors, setErrors] = useState({});
  const [openModal, setOpenModal] = useState(false);

  const parseBooleanSelectValue = (value) => {
    if (value === "SI") return true;
    if (value === "NO") return false;
    return "";
  };

  const uppercaseText = (value) =>
    typeof value === "string" ? value.toUpperCase() : value;

  const normalizeValue = (value) =>
    value?.toUpperCase().replace(/[_\s]/g, "") || "";

  const isPrimerContacto =normalizeValue(localStorage.getItem("area_type")) === "PRIMERCONTACTO";

  const handleCloseModal = () => {
    setOpenModal(false);
    limpiarFormulario();
    setErrors({});
  };

  const openModalEliminar = (data) => {
    setState({
      ...state,
      openModalEliminar: true,
      actaSeleccionada: data,
    });
  };

  const handleCloseEliminar = () => {
    setState({ ...state, openModalEliminar: false });
  };

  const handleCloseDocumento = () => {
    setState({ ...state, openDocumento: false });
  };

  const actaTableData = (state.acta || []).map((item) => ({
    date: item.date ? dayjs(item.date).isValid() ? dayjs(item.date).format("DD-MM-YYYY") : "" : "",
    name: item.name ?? "",
    victim_type: item.victim_type ?? "",
    phone: item.phone ?? "",
    crime_id: item.crime?.crime ?? "",
    no_answer: item.no_answer ?? "",
    case_number: item.case_number ?? "",
  }));

  const descargarDocumentos = async (id) => {
    setLoader({ ...loader, loading: true });
    const response = await services({
      method: "GET",
      service: `act/${id}/pdf`,
      body: null,
    });
    setLoader({ ...loader, loading: false });

    if (response.status === 200) {
      const archivoBase64 = response.data?.archivo || "";
      const rawBase64 = archivoBase64.replace(/^data:application\/pdf;base64,/, "");
      setState({ ...state, openDocumento: true, urlFrame: rawBase64 });
    } else {
      showNotification(
        "error",
        "Ups...Algo Sucedió",
        response?.data?.message || "No se pudo cargar el documento",
        null,
        4,
      );
    }
  };

  const openModalEditar = async (data) => {
      setState({
        ...state,
        openModalEditar: true,
        actaSeleccionada: data,
        // localidades: localidades.data,
      });
  };

  const handleCloseEditar = () => {
    setState({ ...state, openModalEditar: false });
    setErrors({});
  };

  const columns = [
    {
      name: "date",
        label: "FECHA",
        options: {
          filter: true,
          sort: false,
          download: false,
          customBodyRenderLite: (dataIndex) => {
            const fecha = state.acta[dataIndex].date;
            const alta = dayjs(fecha);
            return (
              <div
                className="d-flex align-items-center"
                style={{ height: "60px" }}
              >
                {alta.isValid() ? alta.format("DD-MM-YYYY") : "-"}
              </div>
            );
          },
          filterType: "custom",
          customFilterListOptions: {
            render: (v) => {
              if (v[0] && v[1] && state.FilterChecked) {
                return [
                  `FECHA INICIO: ${dayjs(v[0], "DD-MM-YYYY").format("DD-MM-YYYY")}`,
                  `FECHA FINAL: ${dayjs(v[1], "DD-MM-YYYY").format("DD-MM-YYYY")}`,
                ];
              } else if (v[0] && v[1] && !state.FilterChecked) {
                return `FECHA INICIO: ${dayjs(v[0], "DD-MM-YYYY").format("DD-MM-YYYY")}, FECHA FINAL: ${dayjs(v[1], "DD-MM-YYYY").format("DD-MM-YYYY")}`;
              } else if (v[0]) {
                return `FECHA INICIO: ${dayjs(v[0], "DD-MM-YYYY").format("DD-MM-YYYY")}`;
              } else if (v[1]) {
                return `FECHA FINAL: ${dayjs(v[1], "DD-MM-YYYY").format("DD-MM-YYYY")}`;
              }
              return [];
            },
            update: (filterList, filterPos, index) => {
              if (filterPos === 0) {
                filterList[index].splice(filterPos, 1, "");
              } else if (filterPos === 1) {
                filterList[index].splice(filterPos, 1);
              } else if (filterPos === -1) {
                filterList[index] = [];
              }
    
              return filterList;
            },
          },
          filterOptions: {
            names: [],
            logic: (fecha_creacion, filters) => {
              const fechaMoment = dayjs(fecha_creacion);
  
              if (filters[0] && filters[1]) {
                return (
                  fechaMoment.isBefore(dayjs(filters[0], "DD-MM-YYYY")) ||
                  fechaMoment.isAfter(dayjs(filters[1], "DD-MM-YYYY"))
                );
              } else if (filters[0]) {
                return fechaMoment.isBefore(dayjs(filters[0], "DD-MM-YYYY"));
              } else if (filters[1]) {
                return fechaMoment.isAfter(dayjs(filters[1], "DD-MM-YYYY"));
              }
  
              return false;
            },
            display: (filterList, onChange, index, column) => (
              <div>
                <FormLabel className="mb-2" style={{ fontSize: "12px" }}>
                  RANGO DE FECHAS
                </FormLabel>
                <FormGroup row>
                  <LocalizationProvider
                    adapterLocale="es"
                    dateAdapter={AdapterDayjs}
                  >
                    <DatePicker
                      label="INICIO"
                      slotProps={{ textField: { size: "small" } }}
                      value={
                        filterList[index][0]
                          ? dayjs(filterList[index][0], "DD-MM-YYYY")
                          : null
                      }
                      views={["day", "month", "year"]}
                      onChange={(event) => {
                        filterList[index][0] = dayjs(event).format("DD-MM-YYYY");
                        onChange(filterList[index], index, column);
                      }}
                      style={{ width: "40%" }}
                    />
                  </LocalizationProvider>
    
                  <LocalizationProvider
                    adapterLocale="es"
                    dateAdapter={AdapterDayjs}
                  >
                    <DatePicker
                      label="FINAL"
                      slotProps={{ textField: { size: "small" } }}
                      value={
                        filterList[index][1]
                          ? dayjs(filterList[index][1], "DD-MM-YYYY")
                          : null
                      }
                      views={["day", "month", "year"]}
                      onChange={(event) => {
                        filterList[index][1] = dayjs(event).format("DD-MM-YYYY");
                        onChange(filterList[index], index, column);
                      }}
                      style={{ width: "40%", marginLeft: "10px" }}
                    />
                  </LocalizationProvider>
                </FormGroup>
              </div>
            ),
          },
      },
    },
    {
      name: "name",
      label: "NOMBRE",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => (
          <div className="d-flex align-items-center" style={{ height: "60px" }}>
            {state.acta[dataIndex].name || "-"}
          </div>
        ),
      },
    },
    {
      name: "victim_type",
      label: "TIPO DE VÍCTIMA",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let victim_type = state.acta[dataIndex].victim_type;
          if (victim_type !== null) {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center"
              >
                {victim_type}
              </div>
            );
          } else {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex  justify-content-center align-items-center"
              >
                -
              </div>
            );
          }
        },
      },
    },
    {
      name: "phone",
      label: "TELÉFONO",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => (
          <div className="d-flex align-items-center" style={{ height: "60px" }}>
            {state.acta[dataIndex].phone || "-"}
          </div>
        ),
      },
    },
    {
      name: "crime_id",
      label: "DELITO",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => (
          <div className="d-flex align-items-center" style={{ height: "60px" }}>
            {state.acta[dataIndex].crime?.crime || "-"}
          </div>
        ),
      },
    },
    {
      name: "no_answer",
      label: "MOTIVO",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => (
          <div className="d-flex align-items-center" style={{ height: "60px" }}>
            {state.acta[dataIndex].no_answer || "-"}
          </div>
        ),
      },
    },
    {
      name: "case_number",
      label: "NUC",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => (
          <div className="d-flex align-items-center" style={{ height: "60px" }}>
            {state.acta[dataIndex].case_number || "-"}
          </div>
        ),
      },
    },
    {
      name: "operaciones",
      label: "OPERACIONES",
      options: {
        filter: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => (
          <div className="d-flex align-items-center" style={{ height: "60px" }}>
            <Tooltip title="EDITAR ACTA">
              <div
                style={{ height: 30, width: 30, zIndex: 0, marginRight: 8 }}
                className="cta cta--primary cta--icon icon_btn"
                onClick={() => openModalEditar(state.acta[dataIndex])}
              >
                <IconUI size={"20px"} color={"black"}>
                  <AiOutlineEdit />
                </IconUI>
              </div>
            </Tooltip>
            {(!isPrimerContacto) && (
              <Tooltip title="ELIMINAR ACTA">
                <div
                  style={{ height: 30, width: 30, zIndex: 0 }}
                  className="cta cta--primary cta--icon icon_btn"
                  onClick={() => openModalEliminar(state.acta[dataIndex])}
                >
                  <IconUI size={"20px"} color={"black"}>
                    <AiOutlineDelete />
                  </IconUI>
                </div>
              </Tooltip>
            )}
            <Tooltip title="FORMATO DE ACTA CIRCUNSTANCIADA">
              <div
                style={{ height: 30, width: 30, zIndex: 0 }}
                className="cta cta--primary cta--icon icon_btn"
                onClick={() => {
                  descargarDocumentos(state.acta[dataIndex].id);
                }}
              >
                <IconUI size={"20px"} color={"black"}>
                  <GrDocumentDownload />
                </IconUI>
              </div>
            </Tooltip>
          </div>
        ),
      },
    },
  ];

  const handleName = (e) => {
    setFormulario({ ...formularioState, name: uppercaseText(e.target.value) });
  };

  const handlePhone = (e) => {
    setFormulario({ ...formularioState, phone: e.target.value });
  };

  const handleOfice_number = (e) => {
    setFormulario({ ...formularioState, ofice_number: e.target.value });
  };

  const handleFiscaly_area = (e) => {
    setFormulario({ ...formularioState, fiscaly_area: uppercaseText(e.target.value) });
  };
  const handleVictim_type = (e) => {
    setFormulario({ ...formularioState, 
      victim_type: e.target.value,
      victim_name: e.target.value === "INDIRECTA" ? formularioState.victim_name : "",
    });
    
  };
  const handleVictim_name = (e) => {
    setFormulario({ ...formularioState, victim_name: uppercaseText(e.target.value) });
  };
  const handleCrime_id = (e) => {
    setFormulario({ ...formularioState, crime_id: e ? e.id : null });
  };
  const handleCase_number = (e) => {
    setFormulario({ ...formularioState, case_number: uppercaseText(e.target.value) });
  };
  
  const handleNo_answer = (e) => {
    const value = e.target.value;
    setFormulario({...formularioState, 
      no_answer: value,
      other_answer: value === "OTRO" ? formularioState.other_answer : null,});
  };
  const handleOtherAnswer = (e) => {
    setFormulario({ ...formularioState, other_answer: uppercaseText(e.target.value) });
  };
  const handleComplaint = (e) => {
    const isVictim = parseBooleanSelectValue(e.target.value);
    setFormulario({
      ...formularioState,
      complaint: isVictim,
    });
  };

  const handleSeleccionadoName = (e) => {
    setState({
      ...state,
      actaSeleccionada: {
        ...state.actaSeleccionada,
        name: uppercaseText(e.target.value),
      },
    });
  };
  
  const handleSeleccionadoPhone = (e) => {
    setState({
      ...state,
      actaSeleccionada: {
        ...state.actaSeleccionada,
        phone: e.target.value,
      },
    });
  };
  const handleSeleccionadoOfice_number = (e) => {
    setState({
      ...state,
      actaSeleccionada: {
        ...state.actaSeleccionada,
        ofice_number: uppercaseText(e.target.value),
      },
    });
  };
 
  const handleSeleccionadoFiscaly_area = (e) => {
    setState({
      ...state,
      actaSeleccionada: {
        ...state.actaSeleccionada,
        fiscaly_area: uppercaseText(e.target.value),
      },
    });
  };

  const handleSeleccionadoVictim_type = (e) => {
    setState({
      ...state,
      actaSeleccionada: {
        ...state.actaSeleccionada,
        victim_type: e.target.value,
        victim_name: e.target.value === "INDIRECTA" ? state.actaSeleccionada.victim_name : "",
      },
    });
  };

  const handleSeleccionadoVictim_name = (e) => {
    setState({
      ...state,
      actaSeleccionada: {
        ...state.actaSeleccionada,
        victim_name: uppercaseText(e.target.value),
      },
    });
  };
  const handleSeleccionadoCrime_id = (e) => {
    const value = e ? e.id : null;
    setState({
      ...state,
      actaSeleccionada: {
        ...state.actaSeleccionada,
        crime_id: value,
      },
    });
  };
    
  const handleSeleccionadoCase_number = (e) => {
    setState({
      ...state,
      actaSeleccionada: {
        ...state.actaSeleccionada,
        case_number: uppercaseText(e.target.value),
      },
    });
  };
  const handleSeleccionadoNo_answer = (e) => {
    setState({
      ...state,
      actaSeleccionada: {
        ...state.actaSeleccionada,
        no_answer: uppercaseText(e.target.value),
        other_answer: e.target.value === "OTRO" ? state.actaSeleccionada.other_answer : null,
      },
    });
  };

  const handleSeleccionadoOther_answer = (e) => {
    setState({
      ...state,
      actaSeleccionada: {
        ...state.actaSeleccionada,
        other_answer: uppercaseText(e.target.value),
      },
    });
  };
  const handleSeleccionadoComplaint = (e) => {
    const complaint = parseBooleanSelectValue(e.target.value);
    setState({
      ...state,
      actaSeleccionada: {
        ...state.actaSeleccionada,
        complaint: complaint,
      },
    });
  };

  const validarFormulario = () => {
    let newErrors = {};
    if (!formularioState.name) newErrors.name = "Este campo es requerido";
    if (!formularioState.phone) newErrors.phone = "Este campo es requerido";
    else if (formularioState.phone.length < 10) newErrors.phone = "Favor poner un número de 10 dígitos";
    if (formularioState.victim_type === "INDIRECTA" && !formularioState.victim_name) newErrors.victim_name = "Este campo es requerido";
    // if (!formularioState.crime_id) newErrors.crime_id = "Este campo es requerido";
    if (!formularioState.no_answer) newErrors.no_answer = "Este campo es requerido";
    if (formularioState.no_answer === "OTRO" && !formularioState.other_answer) newErrors.other_answer = "Este campo es requerido";
    if (formularioState.case_number) {
      if (!/^\d{13}$/.test(formularioState.case_number)) {
        newErrors.case_number = "Debe ser un número de 13 dígitos";
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validarEditar = () => {
    let newErrors = {};
    if (!state.actaSeleccionada.name) newErrors.name = "Este campo es requerido";
    if (!state.actaSeleccionada.phone) newErrors.phone = "Este campo es requerido";
    else if (state.actaSeleccionada.phone?.length < 10) newErrors.phone = "Favor poner un número de 10 dígitos";
    if (state.actaSeleccionada.victim_type === "INDIRECTA" && !state.actaSeleccionada.victim_name) newErrors.victim_name = "Este campo es requerido";
    // if (!state.actaSeleccionado.crime_id) newErrors.crime_id = "Este campo es requerido";
    if (!state.actaSeleccionada.no_answer) newErrors.no_answer = "Este campo es requerido";
    if (state.actaSeleccionada.no_answer === "OTRO" && !state.actaSeleccionada.other_answer) newErrors.other_answer = "Este campo es requerido";
    if (state.actaSeleccionada.case_number) {
      if (!/^\d{13}$/.test(state.actaSeleccionada.case_number)) {
        newErrors.case_number = "Debe ser un número de 13 dígitos";
      }
    }      
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const mostrarActas = async () => {
    setLoader(prev => ({ ...prev, loading: true }));

    const actas = await services({ method: "GET", service: "act", body: null });
    const delitos = await services({ method: "GET", service: "crimes", body: null });

    if (actas.status === 200 && delitos.status === 200) {
      setState(prev => ({
        ...prev,
        acta: actas.data,
        delitos: delitos.data
      }));
    } else {
      showNotification("error", "Ups... Algo Ocurrió", "Vuelva a intentarlo más tarde", null, 4);
    }

    setLoader(prev => ({ ...prev, loading: false }));
  };
  const limpiarFormulario = () => {
    setFormulario({
      name: "",
      phone: "",
      ofice_number: "",
      fiscaly_area: "",
      victim_type: "",
      crime_id: "",
      case_number: "",
      no_answer: "",
      complaint: "",
      employee_id: "",
    });
  };

  const crearActa = async () => {
    if (!validarFormulario()) {
      showNotification("error", "Verifica", "Los campos marcados", null, 4);
      return;
    }
    setLoader({ ...loader, loading: true });
    const response = await services({
      method: "POST",
      service: "act",
      body: {
        name: formularioState.name,
        phone: formularioState.phone,
        ofice_number: formularioState.ofice_number,
        fiscaly_area: formularioState.fiscaly_area,
        victim_type: formularioState.victim_type,
        victim_name: formularioState.victim_name,
        crime_id: formularioState.crime_id,
        case_number: formularioState.case_number,
        no_answer: formularioState.no_answer,
        other_answer: formularioState.other_answer,
        complaint: formularioState.complaint,
      },
    });

    if (response.status === 201) {
      await mostrarActas();
      limpiarFormulario();
      setOpenModal(false);
      showNotification("success", "Acta", "Se ha agregado con éxito", null, 4);
    } else {
      showNotification("error", "Ups... Algo sucedió", "Error al agregar la acta", null, 4);
    }
    setLoader({ ...loader, loading: false });
  };

  const editarActa = async () => {
    if (!validarEditar()) {
      showNotification("error", "Verifica", "Los campos marcados", null, 4);
      return;
    }
    setLoader({ ...loader, loading: true });
    const acta = await services({
      method: "PUT",
      service: `act/${state.actaSeleccionada.id}`,
      body: {
        name: state.actaSeleccionada.name,
        phone: state.actaSeleccionada.phone,
        ofice_number: state.actaSeleccionada.ofice_number,
        fiscaly_area: state.actaSeleccionada.fiscaly_area,
        victim_type: state.actaSeleccionada.victim_type,
        victim_name: state.actaSeleccionada.victim_name,
        crime_id: state.actaSeleccionada.crime_id,
        case_number: state.actaSeleccionada.case_number,
        no_answer: state.actaSeleccionada.no_answer,
        other_answer: state.actaSeleccionada.other_answer,
        complaint: state.actaSeleccionada.complaint,
      },
    });
    if (acta.status === 200) {
        let actas = await services({
          method: "GET",
          service: `act`,
          body: null,
        });
        if (actas.status === 200) {
          setState({ ...state, acta: actas.data, openModalEditar: false });
          showNotification(
            "success",
            "Acta Circunstanciada",
            "Editada con Éxito",
            null,
            4,
          );
          setLoader({ ...loader, loading: false });
        } else {
          showNotification(
            "error",
            "Ups... Algo Sucedió",
            "Error al Editar Acta Circunstanciada",
            null,
            4,
          );
          setState({ ...state, openModalEditar: false });
          setLoader({ ...loader, loading: false });
        }
    }else {
          setLoader({ ...loader, loading: false });
          showNotification("error", "Verifica", "Los campos marcados", null, 4);
    }
  };
    
  const eliminarActa = async () => {
    setLoader({ ...loader, loading: true });
    const acta = await services({
      method: "DELETE",
      service: `act/${state.actaSeleccionada.id}`,
      body: null,
    });
    if (acta.status === 200) {
      let actas = await services({
        method: "GET",
        service: `act`,
        body: null,
      });
      if (actas.status === 200) {
        setState({
          ...state,
          acta: actas.data,
          openModalEliminar: false,
        });
        showNotification(
          "success",
          "Acta Circunstanciada",
          "Eliminada con Éxito",
          null,
          4,
        );
        setLoader({ ...loader, loading: false });
      } else {
        setState({ ...state, openModalEliminar: false });
        setLoader({ ...loader, loading: false });
        showNotification(
          "error",
          "Ups... Algo sucedió",
          "Error al Eliminar Acta Circunstanciada",
          null,
          4,
        );
      }
    } else {
      setState({ ...state, openModalEliminar: false });
      setLoader({ ...loader, loading: false });
      showNotification(
        "error",
        "Ups... Algo sucedió",
        "Error al Eliminar Acta Circunstanciada",
        null,
        4,
      );
    }
  };

  useEffect(() => {
    mostrarActas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className=" justify-content-center align-items-start py-4">
        {loader.loading && <LoaderComponent />}
        <div className="container">
          <Grid container justifyContent="flex-end" alignItems="flex-end" spacing={2} sx={{ marginTop: 3 }}>
            <Grid item>
              <ColorButton startIcon={<AddCircleOutlineIcon />} onClick={() => setOpenModal(true)}>
                Nueva Acta Circunstanciada
              </ColorButton>
            </Grid>
          </Grid>
        </div>

        <DataTable data={actaTableData} title="TABLA DE ACTAS CIRCUNSTANCIADAS" columns={columns} />

        <Modal open={openModal} onClose={handleCloseModal} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
          <Box className="contenedorModalUrs" sx={style}>
            <h3 className="TitulosProgramas">NUEVA ACTA CIRCUNSTANCIADA</h3>
            <hr />
            <Grid container columns={12} spacing={3}>
              <Grid item xs={12}>
                <TextField required fullWidth size="small" label="NOMBRE" variant="outlined" error={!!errors.name} helperText={errors.name || ""} value={formularioState.name} onChange={handleName} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField required fullWidth size="small" label="TELÉFONO" variant="outlined" error={!!errors.phone} helperText={errors.phone || ""} value={formularioState.phone} onChange={handlePhone} onKeyPress={onlyNumber} inputProps={{ maxLength: 10 }} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth size="small" label="NÚMERO DE OFICIO" variant="outlined" value={formularioState.ofice_number} onChange={handleOfice_number} onKeyPress={(event) => maxLengthLimitInput(event, 20, "ofice_number")} />
              </Grid>
              <Grid item xs={12}>
                <TextField fullWidth size="small" label="ÁREA FISCALÍA" variant="outlined" value={formularioState.fiscaly_area} onChange={handleFiscaly_area} onKeyPress={(event) => maxLengthLimitInput(event, 50, "fiscaly_area")} />
              </Grid>
              <Grid item xs={12}>
                <TextField fullWidth size="small" label="TIPO DE VÍCTIMA" variant="outlined" select error={!!errors.victim_type} helperText={errors.victim_type || ""} value={formularioState.victim_type || ""} onChange={handleVictim_type}>
                  <MenuItem value="DIRECTA">DIRECTA</MenuItem>
                  <MenuItem value="INDIRECTA">INDIRECTA</MenuItem>
                  <MenuItem value="POTENCIAL">POTENCIAL</MenuItem>
                </TextField>
              </Grid>
              {formularioState.victim_type === "INDIRECTA" && (
                <Grid item xs={12}>
                  <TextField required fullWidth size="small" label="NOMBRE VÍCTIMA" variant="outlined" error={!!errors.victim_name} helperText={errors.victim_name || ""} value={formularioState.victim_name} onChange={handleVictim_name} />
                </Grid>
              )}
              <Grid item xs={12}>
                <Autocomplete
                  options={state.delitos || []}
                  getOptionLabel={(option) => option.crime}
                  fullWidth
                  size="small"
                  id="textFile-area"
                  sx={{
                    borderRadius: "30px",
                  }}
                  value={
                    state.delitos.find(
                      (option) => option.id === formularioState.crime_id,
                    ) || null
                  }
                  onChange={(event, newValue) => handleCrime_id(newValue)}
                  renderInput={(params) => (
                    <TextField
                    {...params}
                      variant="outlined"
                      label="DELITO"
                      error={!!errors.crime_id}
                      helperText={errors.crime_id || ""}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField fullWidth size="small" label="NUC" variant="outlined" error={!!errors.case_number} helperText={errors.case_number || ""} value={formularioState.case_number || ""} onChange={handleCase_number} onKeyPress={onlyNumber} inputProps={{ maxLength: 13 }} />
              </Grid>
              <Grid item xs={12}>
                <TextField required fullWidth size="small" label="MOTIVO" variant="outlined" select error={!!errors.no_answer} helperText={errors.no_answer || ""} value={formularioState.no_answer || ""} onChange={handleNo_answer}>
                  <MenuItem value="NO CONTESTÓ">NO CONTESTÓ</MenuItem>
                  <MenuItem value="MANDÓ A BUZON DE VOZ">MANDÓ A BUZON DE VOZ</MenuItem>
                  <MenuItem value="NO LE INTERESA">NO LE INTERESA</MenuItem>
                  <MenuItem value="LLEGÓ A UN ACUERDO">LLEGÓ A UN ACUERDO</MenuItem>
                  <MenuItem value="CUENTA CON ABOGADO PARTICULAR">CUENTA CON ABOGADO PARTICULAR</MenuItem>
                  <MenuItem value="NO ACUDIÓ A LA CITA">NO ACUDIÓ A LA CITA</MenuItem>
                  <MenuItem value="NO MANDÓ LA DOCUMENTACIÓN REQUERIDA">NO MANDÓ LA DOCUMENTACIÓN REQUERIDA</MenuItem>
                  <MenuItem value="OTRO">OTRO</MenuItem>
                </TextField>
              </Grid>
              {formularioState.no_answer === "OTRO" && (
                <Grid item xs={12}>
                  <TextField required fullWidth size="small" label="OTRO MOTIVO" variant="outlined" error={!!errors.other_answer} helperText={errors.other_answer || ""} value={formularioState.other_answer} onChange={handleOtherAnswer} />
                </Grid>
              )}
              <Grid item xs={12}>
                  <TextField  fullWidth size="small" label="CUENTA CON DENUNCIA" variant="outlined" select error={!!errors.complaint} helperText={errors.complaint || ""} value={formularioState.complaint === true ? "SI" : formularioState.complaint === false ? "NO" : ""} onChange={handleComplaint}>
                    <MenuItem value="SI">SI</MenuItem>
                    <MenuItem value="NO">NO</MenuItem>
                  </TextField>
                </Grid>
              <Grid marginLeft="auto" item>
                <ColorButton onClick={crearActa}>Guardar</ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>


        <Modal open={state.openModalEditar} onClose={handleCloseEditar} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
          <Box className="contenedorModalUrs" sx={style}>
            <h3 className="TitulosProgramas">EDITAR ACTA CIRCUNSTANSIADA</h3>
            <hr />
            <Grid container columns={12} spacing={3}>
              <Grid item xs={12}>
                <TextField required fullWidth size="small" label="NOMBRE" variant="outlined" error={!!errors.name} helperText={errors.name || ""} value={state.actaSeleccionada.name || ""} onChange={handleSeleccionadoName} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField required fullWidth size="small" label="TELÉFONO" variant="outlined" error={!!errors.phone} helperText={errors.phone || ""} value={state.actaSeleccionada.phone || ""} onChange={handleSeleccionadoPhone} onKeyPress={onlyNumber} inputProps={{ maxLength: 10 }} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth size="small" label="NÚMERO DE OFICIO" variant="outlined" value={state.actaSeleccionada.ofice_number} onChange={handleSeleccionadoOfice_number} onKeyPress={(event) => maxLengthLimitInput(event, 20, "ofice_number")} />
              </Grid>
              <Grid item xs={12}>
                <TextField fullWidth size="small" label="ÁREA FISCALÍA" variant="outlined" value={state.actaSeleccionada.fiscaly_area} onChange={handleSeleccionadoFiscaly_area} onKeyPress={(event) => maxLengthLimitInput(event, 50, "fiscaly_area")} />
              </Grid>
              <Grid item xs={12}>
                <TextField fullWidth size="small" label="TIPO DE VÍCTIMA" variant="outlined" select error={!!errors.victim_type} helperText={errors.victim_type || ""} value={state.actaSeleccionada.victim_type || ""} onChange={handleSeleccionadoVictim_type}>
                  <MenuItem value="DIRECTA">DIRECTA</MenuItem>
                  <MenuItem value="INDIRECTA">INDIRECTA</MenuItem>
                  <MenuItem value="POTENCIAL">POTENCIAL</MenuItem>
                </TextField>
              </Grid>
              {state.actaSeleccionada.victim_type === "INDIRECTA" && (
                <Grid item xs={12}>
                  <TextField required fullWidth size="small" label="NOMBRE VÍCTIMA" variant="outlined" error={!!errors.victim_name} helperText={errors.victim_name || ""} value={state.actaSeleccionada.victim_name} onChange={handleSeleccionadoVictim_name} />
                </Grid>
              )}
              <Grid item xs={12}>
                <Autocomplete
                  options={state.delitos || []}
                  getOptionLabel={(option) => option.crime}
                  fullWidth
                  size="small"
                  id="textFile-area"
                  sx={{
                    borderRadius: "30px",
                  }}
                  value={
                    state.delitos.find(
                      (option) =>
                        option.id === state.actaSeleccionada.crime_id,
                    ) || null
                  }
                  onChange={(event, newValue) =>
                    handleSeleccionadoCrime_id(newValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="DELITO"
                      error={!!errors.crime_id}
                      helperText={errors.crime_id || ""}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField fullWidth size="small" label="NUC" variant="outlined" error={!!errors.case_number} helperText={errors.case_number || ""} value={state.actaSeleccionada.case_number || ""} onChange={handleSeleccionadoCase_number} onKeyPress={onlyNumber} inputProps={{ maxLength: 13 }} />
              </Grid>
              <Grid item xs={12}>
                <TextField required fullWidth size="small" label="MOTIVO" variant="outlined" select error={!!errors.no_answer} helperText={errors.no_answer || ""} value={state.actaSeleccionada.no_answer || ""} onChange={handleSeleccionadoNo_answer}>
                  <MenuItem value="NO CONTESTÓ">NO CONTESTÓ</MenuItem>
                  <MenuItem value="MANDÓ A BUZON DE VOZ">MANDÓ A BUZON DE VOZ</MenuItem>
                  <MenuItem value="NO LE INTERESA">NO LE INTERESA</MenuItem>
                  <MenuItem value="LLEGÓ A UN ACUERDO">LLEGÓ A UN ACUERDO</MenuItem>
                  <MenuItem value="CUENTA CON ABOGADO PARTICULAR">CUENTA CON ABOGADO PARTICULAR</MenuItem>
                  <MenuItem value="NO ACUDIÓ A LA CITA">NO ACUDIÓ A LA CITA</MenuItem>
                  <MenuItem value="NO MANDÓ LA DOCUMENTACIÓN REQUERIDA">NO MANDÓ LA DOCUMENTACIÓN REQUERIDA</MenuItem>
                  <MenuItem value="OTRO">OTRO</MenuItem>
                </TextField>
              </Grid>
              {state.actaSeleccionada.no_answer === "OTRO" && (
                <Grid item xs={12}>
                  <TextField required fullWidth size="small" label="OTRO MOTIVO" variant="outlined" error={!!errors.other_answer} helperText={errors.other_answer || ""} value={state.actaSeleccionada.other_answer} onChange={handleSeleccionadoOther_answer} />
                </Grid>
              )}
              <Grid item xs={12}>
                <TextField  fullWidth size="small" label="CUENTA CON DENUNCIA" variant="outlined" select error={!!errors.complaint} helperText={errors.complaint || ""} value={state.actaSeleccionada.complaint === true ? "SI" : state.actaSeleccionada.complaint === false ? "NO" : ""} onChange={handleSeleccionadoComplaint}>
                  <MenuItem value="SI">SI</MenuItem>
                  <MenuItem value="NO">NO</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <ColorButton onClick={editarActa}>Guardar</ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Modal open={state.openModalEliminar} onClose={handleCloseEliminar} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
          <Box className="contenedorModalUrs text-center" sx={style2}>
            <h3 className="TitulosProgramas mb-5">¿ESTÁ SEGURO DE ELIMINAR EL ACTA CIRCUNSTANCIADA?</h3>
            <Grid container columns={12} spacing={4}>
              <Grid item xs={12}>
                <h4>{state.actaSeleccionada.name}</h4>
              </Grid>
              <Grid margin="auto" item>
                <ColorButton onClick={eliminarActa}>Si, Eliminar</ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Modal
          open={state.openDocumento}
          onClose={handleCloseDocumento}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs" sx={style3}>
            <p className="text-center">Documento</p>
            <iframe
              style={{ width: "100%", height: "100%" }}
              id="frameDocumento"
              title="DOCUMENTO"
              src={`data:application/pdf;base64,${state.urlFrame}`}
              className="preview-iframe"
            ></iframe>
            <Button sx={{ mt: 2 }} onClick={handleCloseDocumento}>
              Cerrar
            </Button>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default ActaCircunstanciadaView;
